import { Users, Download, RefreshCw, ChevronUp, ChevronDown, Trash2 } from "lucide-react";

export default function WaitlistTab({ ctx }) {
  const {
    waitlist, divisions, search, setSearch, loading, token,
    loadAll, exportWaitlistCSV, waitlistAction, setPromoting, filteredWaitlist,
  } = ctx;
  if (!waitlist) return null;
  return (
    <>
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-white">Priority Waitlist</h1>
        <div className="flex items-center gap-3">
          <button data-testid="waitlist-export-btn" onClick={exportWaitlistCSV} disabled={!waitlist.waitlist.length}
            className="inline-flex items-center gap-2 text-sm font-bold text-white bg-[#2563EB] hover:bg-[#1d4fd7] disabled:opacity-40 rounded-full px-4 py-2.5 transition-colors">
            <Download size={15} /> Export CSV
          </button>
          <button data-testid="waitlist-refresh-btn" onClick={() => loadAll(token)} disabled={loading}
            className="inline-flex items-center gap-2 text-sm font-bold text-white/70 hover:text-white border border-white/15 rounded-full px-4 py-2.5 transition-colors">
            <RefreshCw size={15} className={loading ? "animate-spin" : ""} /> Refresh
          </button>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-4 gap-4">
        <div className="rounded-2xl bg-white/5 border border-white/10 p-6">
          <Users size={20} className="text-[#2563EB]" />
          <p className="mt-4 text-4xl font-extrabold tracking-tighter text-white">{waitlist.summary.total}</p>
          <p className="mt-1 text-sm font-semibold text-white/50">Total on Waitlist</p>
        </div>
        {divisions.filter((d) => d.status === "active").map((d) => (
          <div key={d.id} className="rounded-2xl bg-white/5 border border-white/10 p-6">
            <p className="text-4xl font-extrabold tracking-tighter text-white">{waitlist.summary.by_division?.[d.name] || 0}</p>
            <p className="mt-1 text-sm font-semibold text-white/50">{d.name}</p>
          </div>
        ))}
      </div>

      <div className="mt-6">
        <input
          data-testid="waitlist-search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search player, parent, email, or division…"
          className="w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-3.5 text-white placeholder-white/30 outline-none focus:border-[#2563EB] transition-colors"
        />
      </div>

      <div className="mt-4 space-y-3">
        {filteredWaitlist.length === 0 && (
          <p data-testid="waitlist-empty" className="px-6 py-10 text-center text-white/40 font-medium">No waitlist entries found.</p>
        )}
        {filteredWaitlist.map((r, i) => {
          const status = r.status || "waiting";
          const badge = {
            waiting: "bg-white/10 text-white/60",
            invited: "bg-amber-500/20 text-amber-300",
            promoted: "bg-emerald-500/20 text-emerald-300",
          }[status] || "bg-white/10 text-white/60";
          const done = status === "promoted";
          return (
            <div key={r.id || i} data-testid={`waitlist-row-${i}`}
              className="rounded-2xl bg-white/5 border border-white/10 p-5 flex flex-wrap items-center justify-between gap-4">
              <div className="flex items-center gap-4 min-w-[220px]">
                <span className="text-2xl font-extrabold text-white/25 w-8 text-center">{i + 1}</span>
                <div>
                  <div className="flex items-center gap-2">
                    <span className={`inline-block rounded-full px-3 py-1 text-xs font-bold uppercase ${badge}`}>{status}</span>
                    <span className="text-sm font-bold text-white">{r.player_name}</span>
                  </div>
                  <p className="mt-1.5 text-sm font-medium text-white/50">
                    {r.school_division} · {r.parent_name} · {r.email}
                    {r.lead_id ? ` · ${r.lead_id}` : ""}
                  </p>
                </div>
              </div>
              {!done && (
                <div className="flex items-center gap-2 flex-wrap">
                  <button data-testid={`waitlist-up-${i}`} onClick={() => waitlistAction(r.id, "move", { direction: "up" })} disabled={i === 0}
                    className="text-white/50 hover:text-white border border-white/15 rounded-full p-2 disabled:opacity-30"><ChevronUp size={15} /></button>
                  <button data-testid={`waitlist-down-${i}`} onClick={() => waitlistAction(r.id, "move", { direction: "down" })}
                    className="text-white/50 hover:text-white border border-white/15 rounded-full p-2"><ChevronDown size={15} /></button>
                  <button data-testid={`waitlist-notify-${i}`} onClick={() => waitlistAction(r.id, "notify")}
                    className="text-xs font-bold text-amber-300 hover:text-amber-200 border border-white/15 rounded-full px-3 py-2">Notify</button>
                  <button data-testid={`waitlist-promote-${i}`} onClick={() => setPromoting({ ...r, division_id: (divisions.find((d) => d.name === r.school_division && d.status === "active" && !d.full) || divisions.find((d) => d.status === "active" && !d.full) || {}).id || "" })}
                    className="text-xs font-bold text-emerald-300 hover:text-emerald-200 border border-white/15 rounded-full px-3 py-2">Promote</button>
                  <button data-testid={`waitlist-remove-${i}`} onClick={() => waitlistAction(r.id, "delete")}
                    className="text-xs font-bold text-red-300 hover:text-red-200 border border-white/15 rounded-full px-3 py-2"><Trash2 size={13} /></button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}
